function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-197.16 -94.964)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 182.74 99.1)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.76 -5.1174)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.7557 -10.513)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 11.5v-11.5h21v23h-21",
  fill: "#007acc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.6035 11.54v0.9373h2.73v8.51h1.9372v-8.51h2.73v-0.92c0-0.5175 0-0.9373-0.021-0.9488 0-0.0172-1.6643-0.023-3.6855-0.023l-3.675 0.0173v0.943zm12.269-0.9602c0.5355 0.138 0.945 0.4025 1.3125 0.8222 0.1942 0.23 0.483 0.6325 0.504 0.736 0 0.0345-0.9083 0.7073-1.4595 1.081-0.021 0.0173-0.105-0.0805-0.189-0.23-0.273-0.4255-0.5513-0.6095-0.987-0.644-0.63-0.046-1.05 0.3163-1.05 0.92 0 0.184 0.0315 0.2875 0.0945 0.437 0.1417 0.3163 0.4042 0.506 1.218 0.897 1.5015 0.7073 2.1525 1.173 2.5462 1.84 0.4463 0.7475 0.546 1.9205 0.2468 2.8003-0.336 0.9602-1.155 1.61-2.3258 1.8227-0.3675 0.069-1.2075 0.0575-1.6012-0.0172-0.84-0.1725-1.6433-0.6325-2.1368-1.2248-0.1942-0.23-0.567-0.8452-0.546-0.8855l0.1995-0.138 0.7875-0.5002 0.5933-0.3795 0.1365 0.2012c0.1732 0.299 0.5617 0.7015 0.7875 0.8395 0.6825 0.3853 1.596 0.3335 2.0475-0.115 0.1942-0.1955 0.2782-0.4025 0.2782-0.69 0-0.2645-0.0367-0.3852-0.1575-0.5865-0.168-0.253-0.504-0.46-1.449-0.92-1.0867-0.506-1.5487-0.828-1.9792-1.3225-0.2468-0.299-0.4725-0.7647-0.5775-1.15-0.0788-0.3335-0.105-1.15-0.0315-1.4777 0.2257-1.15 1.0185-1.955 2.1525-2.185 0.3675-0.0805 1.2337-0.046 1.596 0.0575z",
  fill: "#fff"
})))));

function SvgTypescript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.5563mm",
    height: "6.0854mm",
    viewBox: "0 0 5.5562 6.0854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.8f2d9d64.svg";
export { ForwardRef as ReactComponent };